import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';
import { BaseComponent } from '../base-components/base-component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Utility } from 'src/app/common/utility';
import { ClientGatewayInfo } from 'src/app/models/client-gateway-info';
import { HttpHeaders } from '@angular/common/http';

@Component({
	selector: 'dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent implements OnInit {

	constructor(
		dataService: DataService,
		storeService: StoreService,
		toolsService: ToolsService,
		activatedRoute: ActivatedRoute,
		router: Router
	) {
		super(dataService, storeService, toolsService, activatedRoute, router);
	}

	ngOnInit() {

		Utility.clearSessionCart(this.storeService, this.dataService, this.toolsService);
		this.watchRouteParams();
		this.getHardwareConfiguration();
	}

	getRegister() {

		if (this.registerId) {

			if (this.kioskId) {
				this.router.navigate([`/register/${this.registerId}/${this.kioskId}`]);
			} else {
				this.router.navigate([`/register/${this.registerId}`]);
			}

		}

	}

	gotoGateway(){
		let path = this.storeService.kioskSettings.enableTicketPrint ? 'gateway' : 'register';
		if (this.registerId) {

			if (this.kioskId) {
				this.router.navigate([`/${path}/${this.registerId}/${this.kioskId}`]);
			} else {
				this.router.navigate([`/${path}/${this.registerId}`]);
			}

		}
	}

	getHardwareConfiguration() {

		this.dataService.get<ClientGatewayInfo>('http://localhost:56885/api/status', null, false, false)
			.catch(error => {

				var postData = {
					registerId: this.registerId,
					clientGateway: null
				};				

				this.configureRegister(postData);

			}).then(clientGateway => {

				var postData = {
					registerId: this.registerId,
					clientGateway: clientGateway
				};

				this.configureRegister(postData);
			});

	}

	configureRegister(postData: any) {
		const requestOptions = {
			headers: new HttpHeaders({
			}),
			crossDomain: true,
            withCredentials: true 
		   };
		this.dataService.post<any>(`/CustomRegisters/ConfigureRegister`, postData,requestOptions)
			.catch(error => {
				console.error(`Error Configuring Register: ${error}`);

			}).then(response => {

			});

	}

}
